var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V10.1308C16 7.26002 15.3827 5.04877 12.0295 5.04877C10.418 5.04877 9.33649 5.93402 8.89499 6.77377H8.84829V5.31727H5.67087V15.9993H8.9804V10.71C8.9804 9.31727 9.2441 7.97077 10.9669 7.97077C12.665 7.97077 12.69 9.56002 12.69 10.7995V15.9995L16 16Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.282641 5.31799H3.59517V16H0.282641V5.31799Z",
    fill: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93705 2.08939e-05C1.55495 -0.00175856 1.18094 0.110162 0.862497 0.321574C0.544052 0.532987 0.295533 0.834357 0.148488 1.18743C0.00144339 1.5405 -0.0374963 1.92935 0.0366123 2.30462C0.110721 2.67989 0.294536 3.02465 0.564723 3.29514C0.83491 3.56563 1.17928 3.74966 1.55413 3.82385C1.92898 3.89804 2.31739 3.85906 2.67007 3.71185C3.02274 3.56464 3.32378 3.31584 3.53495 2.99703C3.74613 2.67823 3.85792 2.3038 3.85614 1.92127C3.85594 1.41178 3.65369 0.923223 3.29383 0.562962C2.93398 0.2027 2.44597 0.000219666 1.93705 2.08939e-05Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3192c7cd4b8884cf7becfe4f86dad714.svg";
export { ForwardRef as ReactComponent };